import { Routes, Route } from "react-router-dom";
import Layout from "../components/layout/Layout";
import Country from "../features/country/Country";
import State from "../features/state/State";
import City from "../features/city/City";
import ItemCategory from "../features/itemcategory/ItemCategory";
import Item from "../features/item/Item";
import CreateItem from "../features/item/CreateItem";
import Process from "../features/process/Process";
import Priority from "../features/priority/Priority";
import Party from "../features/party/Party";
import CreateParty from "../features/party/CreateParty";
import Karigar from "../features/karigar/Karigar";
import CreateKarigar from "../features/karigar/CreateKarigar";
import Order from "../features/order/Order";
import CreateOrder from "../features/order/CreateOrder";
import Ghat from "../features/ghat/Ghat";
import CreateGhat from "../features/ghat/CreateGhat";
import CreateGhatReceipt from "../features/ghatreceipt/CreateGhatReceipt";
import GhatReceipt from "../features/ghatreceipt/GhatReceipt";
import ProductSubCategory from "../features/productsubcategory/ProductSubCategory";
import Purity from "../features/purity/Purity";
import Unit from "../features/unit/Unit";
import Charges from "../features/charges/Charges";
import User from "../features/user/User";
import CreateUser from "../features/user/CreateUser";
import UserType from "../features/userType/UserType";
import CreateUserType from "../features/userType/CreateUserType";
import Menu from "../features/menu/Menu";
import CreateMenu from "../features/menu/CreateMenu";
import Rights from "../features/rights/Rights";
import CreateRights from "../features/rights/CreateRights";
import Palish from "../features/palish/Palish";
import CreatePalish from "../features/palish/CreatePalish";
import PalishReceipt from "../features/palishreceipt/PalishReceipt";
import CreatePalishReceipt from "../features/palishreceipt/CreatePalishReceipt";
import NewLogIn from "../features/login/NewLogin";
import Dull from "../features/dull/Dull";
import CreateDull from "../features/dull/CreateDull";
import DullReceipt from "../features/dullreceipt/DullReceipt";
import CreateDullReceipt from "../features/dullreceipt/CreateDullReceipt";
import Mina from "../features/mina/Mina";
import CreateMina from "../features/mina/CreateMina";
import MinaReceipt from "../features/minareceipt/MinaReceipt";
import CreateMinaReceipt from "../features/minareceipt/CreateMinaReceipt";
import Jadai from "../features/jadai/Jadai";
import CreateJadai from "../features/jadai/CreateJadai";
import JadaiReceipt from "../features/jadaireceipt/JadaiReceipt";
import CreateJadaiReceipt from "../features/jadaireceipt/CreateJadaiReceipt";
import Bandhai from "../features/bandhai/Bandhai";
import CreateBandhai from "../features/bandhai/CreateBandhai";
import BandhaiReceipt from "../features/bandhaireceipt/BandhaiReceipt";
import CreateBandhaiReceipt from "../features/bandhaireceipt/CreateBandhaiReceipt";
import MinaPendingOrderReport from "../features/reports/reportsForms/MinaPendingOrderReport";
import DullPendingOrderReport from "../features/reports/reportsForms/DullPendingOrderReport";
import PalishPendingOrderReport from "../features/reports/reportsForms/PalishPendingOrderReport";
import GhatIssueVoucherPDF from "../features/ghat/GhatIssueVoucherPDF";
import GhatPendingOrderReport from "../features/reports/reportsForms/GhatPendingOrderReport";
import BandhaiIssueVoucherPDF from "../features/bandhai/BandhaiIssueVoucherPDF";
import JadaiIssueVoucherPDF from "../features/jadai/JadaiIssueVoucherPDF";
import PalishIssueVoucherPDF from "../features/palish/PalishIssueVoucherPDF";
import DullIssueVoucherPDF from "../features/dull/DullIssueVoucherPDF";
import MinaIssueVoucherPDF from "../features/mina/MinaIssueVoucherPDF";
import BandhaiPendingOrderReport from "../features/reports/reportsForms/BandhaiPendingOrderReport";
import JadaiPendingOrderReport from "../features/reports/reportsForms/JadaiPendingOrderReport";
import KarigarPhineLedgerReportForm from "../features/reports/reportsForms/KarigarPhineLedgerReportForm";
import KarigarPhineLedgerReportView from "../features/reports/reportsForms/KarigarPhineLedgerReportView";
import KarigarAmountLedgerReportForm from "../features/reports/reportsForms/KarigarAmountLedgerReportForm";
import KarigarAmountLedgerReportView from "../features/reports/reportsForms/KarigarAmountLedgerReportView";
import GhatKarigarLedgerReportForm from "../features/reports/reportsForms/GhatKarigarLedgerReportForm";
import GhatKarigarLedgerReportView from "../features/reports/reportsForms/GhatKarigarLedgerReportView";
import BandhaiKarigarLedgerReportForm from "../features/reports/reportsForms/BandhaiKarigarLedgerReportForm";
import BandhaiKarigarLedgerReportView from "../features/reports/reportsForms/BandhaiKarigarLedgerReportView";
import PalishKarigarLedgerReportView from "../features/reports/reportsForms/PalishKarigarLedgerReportView";
import PalishKarigarLedgerReportForm from "../features/reports/reportsForms/PalishKarigarLedgerReportForm";
import DullKarigarLedgerReportForm from "../features/reports/reportsForms/DullKarigarLedgerReportForm";
import DullKarigarLedgerReportView from "../features/reports/reportsForms/DullKarigarLedgerReportView";
import MinaKarigarLedgerReportView from "../features/reports/reportsForms/MinaKarigarLedgerReportView";
import MinaKarigarLedgerReportForm from "../features/reports/reportsForms/MinaKarigarLedgerReportForm";
import JadaiKarigarLedgerReportForm from "../features/reports/reportsForms/JadaiKarigarLedgerReportForm";
import JadaiKarigarLedgerReportView from "../features/reports/reportsForms/JadaiKarigarLedgerReportView";
import GhatReceiptVoucherPDF from "../features/ghatreceipt/GhatReceiptVoucherPDF";
import BandhaiReceiptVoucherPDF from "../features/bandhaireceipt/BandhaiReceiptVoucherPDF";
import PalishReceiptVoucherPDF from "../features/palishreceipt/PalishReceiptVoucherPDF";
import DullReceiptVoucherPDF from "../features/dullreceipt/DullReceiptVoucherPDF";
import MinaReceiptVoucherPDF from "../features/minareceipt/MinaReceiptVoucherPDF";
import JadaiReceiptVoucherPDF from "../features/jadaireceipt/JadaiReceiptVoucherPDF";
import OrderStatusPDF from "../features/order/OrderStatusPDF";
import PaymentReceipt from "../features/paymentreceipt/PaymentReceipt";
import BandhaiSettlementForm from "../features/settlementform/settlementform/BandhaiSettlementForm";
import StockReportForm from "../features/reports/reportsForms/StockReportForm";
import StockReportView from "../features/reports/reportsForms/StockReportView";
import PartAddtoOrders from "../features/addparts/PartAddtoOrders";
import CreatePartAddtoOrders from "../features/addparts/CreatePartAddtoOrders";
import OrderLabeling from "../features/orderlabeling/OrderLabeling";
import GenerateOrderLabeling from "../features/orderlabeling/GenerateOrderLabeling";
import SplitItem from "../features/splititem/SplitItem";
import SplitItemHistory from "../features/splititem/SplitItemHistory";
import PurchaseList from "../features/purchaseform/PurchaseList";
import CreatePurchaseForm from "../features/purchaseform/CreatePurchaseForm";
import Dashboard from "../features/dashboard/Dashboard";

const MainRouter = () => {
  return (
    <Routes>
      <Route path="login" element={<NewLogIn />} />
      <Route path="ghatissue/:ghat_guid" element={<GhatIssueVoucherPDF />} />
      <Route
        path="ghatissuereceipt/:ghat_guid"
        element={<GhatReceiptVoucherPDF />}
      />
      <Route
        path="bandhaireceipt/:bandhai_receipt_guid"
        element={<BandhaiReceiptVoucherPDF />}
      />
      <Route
        path="palishreceipt/:palish_receipt_guid"
        element={<PalishReceiptVoucherPDF />}
      />
      <Route
        path="dullreceipt/:dull_receipt_guid"
        element={<DullReceiptVoucherPDF />}
      />
      <Route
        path="minareceipt/:mina_receipt_guid"
        element={<MinaReceiptVoucherPDF />}
      />
      <Route
        path="jadaireceipt/:jadai_receipt_guid"
        element={<JadaiReceiptVoucherPDF />}
      />
      <Route path="order/:order_guid" element={<OrderStatusPDF />} />
      <Route
        path="bandhaiissue/:bandhai_issue_guid"
        element={<BandhaiIssueVoucherPDF />}
      />
      <Route
        path="jadaiissue/:jadai_issue_guid"
        element={<JadaiIssueVoucherPDF />}
      />
      <Route
        path="palishissue/:palish_guid"
        element={<PalishIssueVoucherPDF />}
      />
      <Route
        path="dullissue/:dull_issue_guid"
        element={<DullIssueVoucherPDF />}
      />
      <Route
        path="minaissue/:mina_issue_guid"
        element={<MinaIssueVoucherPDF />}
      />
      <Route
        path="karigar-phine-ledger-report/:fromdate/:todate/:karigar_id"
        element={<KarigarPhineLedgerReportView />}
      />
      <Route
        path="karigar-amount-ledger-report/:fromdate/:todate/:karigar_id"
        element={<KarigarAmountLedgerReportView />}
      />
      <Route
        path="/ghat-karigar-ledger-report/:fromdate/:todate/:karigar_id"
        element={<GhatKarigarLedgerReportView />}
      />
      <Route
        path="/bandhai-karigar-ledger-report/:fromdate/:todate/:karigar_id"
        element={<BandhaiKarigarLedgerReportView />}
      />
      <Route
        path="/palish-karigar-ledger-report/:fromdate/:todate/:karigar_id"
        element={<PalishKarigarLedgerReportView />}
      />
      <Route
        path="/dull-karigar-ledger-report/:fromdate/:todate/:karigar_id"
        element={<DullKarigarLedgerReportView />}
      />
      <Route
        path="/mina-karigar-ledger-report/:fromdate/:todate/:karigar_id"
        element={<MinaKarigarLedgerReportView />}
      />
      <Route
        path="/jadai-karigar-ledger-report/:fromdate/:todate/:karigar_id"
        element={<JadaiKarigarLedgerReportView />}
      />

      <Route
        path="/stockreport/:CategoryID/:SubCategoryID/:ProductID"
        element={<StockReportView />}
      />

      <Route path="/" element={<Layout />}>
        <Route path="" element={<Dashboard />} />
        {/* REPORTS */}
        <Route
          path="mina-issue-pending-order-report"
          element={<MinaPendingOrderReport />}
        />
        <Route
          path="dull-issue-pending-order-report"
          element={<DullPendingOrderReport />}
        />
        <Route
          path="palish-issue-pending-order-report"
          element={<PalishPendingOrderReport />}
        />
        <Route
          path="ghat-issue-pending-order-report"
          element={<GhatPendingOrderReport />}
        />
        <Route
          path="bandhai-issue-pending-order-report"
          element={<BandhaiPendingOrderReport />}
        />
        <Route
          path="jadai-issue-pending-order-report"
          element={<JadaiPendingOrderReport />}
        />
        <Route
          path="karigar-phine-ledger-report"
          element={<KarigarPhineLedgerReportForm />}
        />
        <Route
          path="karigar-amount-ledger-report"
          element={<KarigarAmountLedgerReportForm />}
        />
        <Route
          path="ghat-karigar-ledger-report"
          element={<GhatKarigarLedgerReportForm />}
        />
        <Route
          path="bandhai-karigar-ledger-report"
          element={<BandhaiKarigarLedgerReportForm />}
        />
        <Route
          path="palish-karigar-ledger-report"
          element={<PalishKarigarLedgerReportForm />}
        />
        <Route
          path="dull-karigar-ledger-report"
          element={<DullKarigarLedgerReportForm />}
        />
        <Route
          path="Mina-karigar-ledger-report"
          element={<MinaKarigarLedgerReportForm />}
        />
        <Route
          path="jadai-karigar-ledger-report"
          element={<JadaiKarigarLedgerReportForm />}
        />
        <Route path="stockreport" element={<StockReportForm />} />

        {/* MASTER */}
        <Route path="country" element={<Country />} />
        <Route path="state" element={<State />} />
        <Route path="city" element={<City />} />

        <Route path="charges" element={<Charges />} />
        <Route path="itemcategory" element={<ItemCategory />} />
        <Route path="productsubcategory" element={<ProductSubCategory />} />
        <Route path="item" element={<Item />} />
        <Route path="item/create" element={<CreateItem />} />
        <Route path="item/edit" element={<CreateItem />} />
        <Route path="process" element={<Process />} />
        <Route path="priority" element={<Priority />} />
        <Route path="party" element={<Party />} />
        <Route path="party/create" element={<CreateParty />} />
        <Route path="party/edit" element={<CreateParty />} />
        <Route path="karigar" element={<Karigar />} />
        <Route path="karigar/create" element={<CreateKarigar />} />
        <Route path="karigar/edit" element={<CreateKarigar />} />

        <Route path="user" element={<User />} />
        <Route path="user/create" element={<CreateUser />} />
        <Route path="user/edit" element={<CreateUser />} />
        <Route path="usertype" element={<UserType />} />
        <Route path="usertype/create" element={<CreateUserType />} />
        <Route path="usertype/edit" element={<CreateUserType />} />
        <Route path="menu" element={<Menu />} />
        <Route path="menu/create" element={<CreateMenu />} />
        <Route path="menu/edit" element={<CreateMenu />} />
        <Route path="rights" element={<Rights />} />
        <Route path="rights/create" element={<CreateRights />} />
        <Route path="rights/edit" element={<CreateRights />} />
        <Route path="purity" element={<Purity />} />
        <Route path="paymentreceipt" element={<PaymentReceipt />} />
        <Route path="unit" element={<Unit />} />
        {/* ORDER */}
        <Route path="order" element={<Order />} />
        <Route path="order/create" element={<CreateOrder />} />
        <Route path="order/edit" element={<CreateOrder />} />

        {/* PROCESS */}
        <Route path="ghatissue" element={<Ghat />} />
        <Route path="ghatissue/create" element={<CreateGhat />} />
        <Route path="ghatissue/edit" element={<CreateGhat />} />

        <Route path="orderlabeling" element={<OrderLabeling />} />
        <Route
          path="orderlabeling/generate"
          element={<GenerateOrderLabeling />}
        />
        <Route path="splititem" element={<SplitItemHistory />} />
        <Route path="splititem/create" element={<SplitItem />} />

        <Route path="purchaseentry" element={<PurchaseList />} />
        <Route path="purchaseentry/edit" element={<CreatePurchaseForm />} />
        <Route path="purchaseentry/create" element={<CreatePurchaseForm />} />

        <Route path="ghatissuereceipt" element={<GhatReceipt />} />
        <Route path="ghatissuereceipt/edit" element={<CreateGhatReceipt />} />
        <Route path="ghatissuereceipt/create" element={<CreateGhatReceipt />} />

        <Route path="partaddtoorders" element={<PartAddtoOrders />} />
        <Route
          path="partaddtoorders/edit"
          element={<CreatePartAddtoOrders />}
        />
        <Route
          path="partaddtoorders/create"
          element={<CreatePartAddtoOrders />}
        />

        <Route path="palish" element={<Palish />} />
        <Route path="palish/create" element={<CreatePalish />} />
        <Route path="palish/edit" element={<CreatePalish />} />

        <Route path="palishreceipt" element={<PalishReceipt />} />
        <Route path="palishreceipt/create" element={<CreatePalishReceipt />} />
        <Route path="palishreceipt/edit" element={<CreatePalishReceipt />} />

        <Route path="dull" element={<Dull />} />
        <Route path="dull/create" element={<CreateDull />} />
        <Route path="dull/edit" element={<CreateDull />} />

        <Route path="dullreceipt" element={<DullReceipt />} />
        <Route path="dullreceipt/create" element={<CreateDullReceipt />} />
        <Route path="dullreceipt/edit" element={<CreateDullReceipt />} />

        <Route path="mina" element={<Mina />} />
        <Route path="mina/create" element={<CreateMina />} />
        <Route path="mina/edit" element={<CreateMina />} />

        <Route path="minareceipt" element={<MinaReceipt />} />
        <Route path="minareceipt/create" element={<CreateMinaReceipt />} />
        <Route path="minareceipt/edit" element={<CreateMinaReceipt />} />

        <Route path="jadai" element={<Jadai />} />
        <Route path="jadai/create" element={<CreateJadai />} />
        <Route path="jadai/edit" element={<CreateJadai />} />

        <Route path="jadaireceipt" element={<JadaiReceipt />} />
        <Route path="jadaireceipt/create" element={<CreateJadaiReceipt />} />
        <Route path="jadaireceipt/edit" element={<CreateJadaiReceipt />} />

        <Route path="bandhai" element={<Bandhai />} />
        <Route path="bandhai/create" element={<CreateBandhai />} />
        <Route path="bandhai/edit" element={<CreateBandhai />} />
        <Route
          path="bandhaisettlementform"
          element={<BandhaiSettlementForm />}
        />

        <Route path="bandhaireceipt" element={<BandhaiReceipt />} />
        <Route
          path="bandhaireceipt/create"
          element={<CreateBandhaiReceipt />}
        />
        <Route path="bandhaireceipt/edit" element={<CreateBandhaiReceipt />} />
        <Route path="*" element={<h1>404</h1>} />
      </Route>
    </Routes>
  );
};

export default MainRouter;
